import React from 'react';

import Styled from '../AssessmentForm/AssessmentForm.styles';
import { Question } from '../../types/DataTypes';
import { AssessmentResultAnswer } from '../../types';

type Props = {
  question: Question;
  answer: AssessmentResultAnswer;
  onAnswerChange: (question: Question, updatedAnswer: AssessmentResultAnswer) => void;
  disabled?: boolean;
}

const FreeFormText: React.FC<Props> = (props: Props) => {
  const {
    question, onAnswerChange, answer, disabled,
  } = props;

  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => onAnswerChange(question, {
    type: question.questionType,
    answers: [{
      text: event.target.value,
      uid: '',
    }],
  });

  return (
    <Styled.TextField
      maxRows={4}
      multiline
      value={answer.answers.length ? answer.answers[0].text : ''}
      onChange={handleTextChange}
      variant="outlined"
      disabled={disabled}
    />
  );
};

export default FreeFormText;
